import { observer } from "mobx-react-lite";
import { Colors } from "../../../utils/colors";
import { UserAvatar } from "../../../components/userAvatar/UserAvatar";
import { AllPlayersProgressIndicator } from "./AllPlayerProgressIndicator";
import {
  useMatchDetailsStore,
  useMatchStatsStore,
} from "../../../stores/StoreContext";
import { DownloadUltraAppOverlay } from "../../ultraPromo/components/DownloadUltraAppOverlay";

export const AllPlayersComparison = observer(() => {
  const matchStatsStore = useMatchStatsStore();
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <div style={{ position: "relative" }}>
      <AllPlayersAvatarView />
      <div
        style={{
          marginTop: 14,
          backgroundColor: Colors.lightGreen,
          borderRadius: 10,
          marginLeft: 10,
          marginRight: 10,
          paddingLeft: 14,
          paddingRight: 14,
          paddingTop: 20,
          paddingBottom: 20,
          display: "flex",
          flexDirection: "column",
          rowGap: 10,
        }}>
        {matchStatsStore.getAllPlayersProgressStats().map((item) => (
          <AllPlayersProgressIndicator
            showPercentage={item.showPercentage}
            title={item.title}
            player1={{
              id: item.player1.id,
              percentage: item.player1.percentage,
              value: item.player1.value,
            }}
            player2={{
              id: item.player2.id,
              percentage: item.player2.percentage,
              value: item.player2.value,
            }}
            player3={{
              id: item.player3.id,
              percentage: item.player3.percentage,
              value: item.player3.value,
            }}
            player4={{
              id: item.player4.id,
              percentage: item.player4.percentage,
              value: item.player4.value,
            }}
          />
        ))}
      </div>
      {matchDetailsStore.isPromoMode ? (
        <DownloadUltraAppOverlay style={{ top: 50 }} />
      ) : null}
    </div>
  );
});

const AllPlayersAvatarView = () => {
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <div
      style={{
        marginTop: 30,
        display: "flex",
        flexDirection: "row",
        marginLeft: 10,
        marginRight: 10,
        position: "relative",
      }}>
      {[...matchDetailsStore.teamMates, ...matchDetailsStore.opponents].map(
        (item) => (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              justifyContent: "center",
            }}>
            <div style={{ position: "relative" }}>
              <UserAvatar
                size={50}
                avatar={{
                  image: item.userImageUrl ?? "",
                  name: item.name ?? "",
                }}
              />
              <div
                style={{
                  border: `2px solid ${Colors.green}`,
                  width: 16,
                  height: 16,
                  borderRadius: 100,
                  backgroundColor:
                    matchDetailsStore.colorMap.get(
                      parseInt(item.userId ?? "0")
                    ) ?? Colors.darkBrown,
                  position: "absolute",
                  right: 0,
                  bottom: 0,
                }}
              />
            </div>
          </div>
        )
      )}
    </div>
  );
};
